import { default as Keypress } from "keypress.js";
var elements = new WeakMap();
console.log(Keypress);
const listener = new Keypress.Listener();

var keyp = (keys) => {

    console.log("in key");
    listener.listen();
    listener.register_many(keys);
    listener.unregister_many(keys);
  

}
export default keyp;